import React from 'react'
import _get from 'lodash/get'
import { connect as connectRedux } from 'react-redux'
import OptimizelyFeature from '../OptimizelyFeature/index'
import DetailPageV2 from '../DetailPage/index'
import DetailPageV3 from './DetailPageV3'

function DetailPageV3Optimizely (props) {
  const {
    location,
    history,
    apolloClient,
    resolver,
  } = props

  const locationPath = _get(location, 'pathname')
  const resolverPath = resolver.getIn(['data', 'path'])
  const locationIsSynced = locationPath === resolverPath

  if (!locationIsSynced) {
    return null
  }

  return <div className="detail-page-v3-optimizely">
    <OptimizelyFeature
      flag="details_page_v3"
      variation="control"
      isDefault={true}
      anon={false}
      noWrapper
    >
      <DetailPageV2
        location={location}
        history={history}
        apolloClient={apolloClient}
      />
    </OptimizelyFeature>
    <OptimizelyFeature
      flag="details_page_v3"
      variation="show_details_page_v3"
      noWrapper
    >
      <DetailPageV3
        location={location}
        history={history}
        apolloClient={apolloClient}
      />
    </OptimizelyFeature>
  </div>
}

export default connectRedux((state) => ({
  resolver: state.resolver,
}))(DetailPageV3Optimizely)
